import styled from 'styled-components';

const Label = styled.p`
  color: ${props => props.theme.label};
  font-size: 14px;
  text-transform: capitalize;
`;

export default Label;
